import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppState } from '../../../../store/state/app.state';
import { Store } from '@ngrx/store';

import { UtilService } from '../../../../shared/services/api-services/util.service';
import { ProductChoice } from 'src/app/model/ngrx/Product-Choice.model';
import { QuoteDataCaptureService } from 'src/app/shared/services/api-services/quote-datacapture.service';
import { AlertModal } from 'src/app/model/alert';
import { ActivatedRoute } from '@angular/router';
import { SERVICE_END_POINT } from 'src/app/shared';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { debounceTime, filter, take } from 'rxjs/operators';
@Component({
  selector: 'app-quote-variants',
  templateUrl: './quote-variants.component.html',
  styleUrls: ['./quote-variants.component.scss']
})
export class QuoteVariantsComponent implements OnInit {

  public cardNumber: number;
  public editFlag: boolean;
  public changeCard: boolean;
  productChoiceStore: Observable<ProductChoice[]>;
  productChoiceData: ProductChoice;
  requoteLTAModalConfig: AlertModal;
  requoteLTAFlag: boolean = false;
  yourOptions;
  contentData;
  CMSData;

  constructor(private utilService: UtilService, private quoteDatacaptureService: QuoteDataCaptureService,
              private store: Store<AppState>, private activatedRoute: ActivatedRoute) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.youroptionscalculations;
    this.productChoiceStore = store.select(STORE_VAL.product_choice);
    this.productChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.productChoiceData = res[0];
        //console.log('productChoiceData->', this.productChoiceData);
      }
    });
    this.store.select(STORE_VAL.req_quote_calculation).subscribe(res => {
      if (res.length > 0) {
        this.yourOptions = res[0];
        if (this.yourOptions.reQuoteFlag) {
          this.requoteLTAFlag = this.yourOptions.reQuoteFlag === true ? true : false;
        }
      } else if(!this.quoteDatacaptureService.checkIfObjEmpty(res)) {
        this.yourOptions = null;
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.requoteLTAModalConfig = this.contentData.modalConfigLTARequote;
    if(this.productChoiceData && this.productChoiceData.selectedProduct === 'C') {
      this.triggerUnderWritingAPI();
    }
   }
   GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourProductOptions;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.modalConfigLTARequote.header = this.CMSData.string_PensionAnnuityRequoteTitle;
        // tslint:disable-next-line:max-line-length
        this.contentData.modalConfigLTARequote.content = this.CMSData.string_PensionAnnuityRequoteText;
        this.contentData.modalConfigLTARequote.footerPrimaryBtnLabel = this.CMSData.commonBlock.string_OKCTALabel;
      }
    });
  }
  triggerUnderWritingAPI() {
    this.quoteDatacaptureService.triggerUnderwriting(true).subscribe(res => {
      
    }, err => {
    });
  }

  getEmittedCardNumber(val) {
    const cardNumber = val.card ? val.card.cardNumber : null;
    const editFlag = val.flag;
    const values = { cardNumber, editFlag };
    this.utilService.setEdifFields(values);
    val.flag ? this.scrollToTop(500) : null;
  }

  setCardNumber() {
    return this.cardNumber;
  }

  getEditFlag(val) {
    const cardNumber = val.card.cardNumber;
    const editFlag = val.flag;
    const values = { cardNumber, editFlag };
    this.utilService.setEdifFields(values);
    // this.scrollToTop(500);
  }

  getEmittedPageMode(param) {
    if (this.changeCard) {
      this.changeCard = !this.changeCard;
    } else {
      this.changeCard = true;
    }
    const scrollHeight = window.scrollY;
    const scrHeight = window.innerHeight;
    // if (param.index > 3) {
    //   window.scrollTo(0, scrollHeight + 800);
    // } else {
    //   window.scrollTo(0, scrollHeight + 400);
    // }
  }
  scrollToTop(scrollDuration) {
    const scrollHeight = window.scrollY;
    const scrollStep = Math.PI / (scrollDuration / 15);
    const cosParameter = scrollHeight / 2;
    let scrollCount = 0;
    let scrollMargin;
    if(window.innerWidth <= 1035) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
   } else {
      const scrollInterval = setInterval(function () {
        if (window.scrollY !== 0) {
          scrollCount = scrollCount + 1;
          scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
          window.scrollTo(0, (scrollHeight - scrollMargin));
        } else {
          clearInterval(scrollInterval);
        }
      }, 15);
    }
  }
  // scrollToBottom() {
  //   const scrollHeight = window.scrollY;
  //   const scrollInterval = setInterval(function () {
  //     if (window.scrollY !== 0) {
  //       window.scrollTo(0, scrollHeight);
  //     } else {
  //       clearInterval(scrollInterval);
  //     }
  //   }, 15);
  // }
  closeLTARequoteModal () {
    this.requoteLTAFlag = false;
  }
}
